module.exports = __webpack_public_path__ + "static/media/female-blue-small.14c2f590.png";